// room.validation.js
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import addUserValidation from "../../constant/validations/form.validation.messages";

export const getValidationSchema = (propertyData) => {
  return Yup.object().shape({
    category: Yup.string().required(addUserValidation.category),
    roomDescription: Yup.string()
      .required(addUserValidation.roomDescriptionLength)
      .max(1500, addUserValidation.roomDescriptionLength),
    regularPrice: Yup.string().required(addUserValidation.require),

    threeHrPrice: Yup.string().when(["category"], {
      is: (category) =>
        String(category) === "1" && propertyData?.allowHourly === true,
      then: (schema) => schema.required(addUserValidation.require),
      otherwise: (schema) => schema.notRequired(),
    }),
    sixHrPrice: Yup.string().when(["category"], {
      is: (category) =>
        String(category) === "1" && propertyData?.allowHourly === true,
      then: (schema) => schema.required(addUserValidation.require),
      otherwise: (schema) => schema.notRequired(),
    }),
    nineHrPrice: Yup.string().when(["category"], {
      is: (category) =>
        String(category) === "1" && propertyData?.allowHourly === true,
      then: (schema) => schema.required(addUserValidation.require),
      otherwise: (schema) => schema.notRequired(),
    }),

    amenities: Yup.array().min(1).of(Yup.string().required()).required(),
  });
};
